module.exports = __webpack_public_path__ + "assets/media/sound9.e631ff38.mp3";